// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Cart } from "@insite/client-framework/Services/CartService";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface OwnProps {
    cart?: Cart;
}

interface DeliveryInventoryMessageStyles {
    container?: InjectableCss;
    message?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export const deliveryInventoryMessageStyles: DeliveryInventoryMessageStyles = {};

const styles = deliveryInventoryMessageStyles;
const DeliveryInventoryMessage: FC<OwnProps> = ({ cart }) => {
    if (!cart?.properties.deliveryInventoryMessage) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.message}>
                <Icon {...styles.icon} />
                {cart.properties.deliveryInventoryMessage}
            </Typography>
        </StyledWrapper>
    );
};

export default DeliveryInventoryMessage;
